module.exports = __webpack_public_path__ + "static/img/花卉养护管理软件.5cf5806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/花卉养护管理软件.jpg
// module id = kLNA
// module chunks = 15